import React, {Component} from 'react';
import * as firebase from 'firebase';
import MetaTags from 'react-meta-tags';

export default class EditPersonal extends Component {
  constructor(){
    super();
    this.state = {
      birthday: '',
      otherMail: '',
      phone: '',
      address: ''
    }
    this.handleChangeBirthday = this.handleChangeBirthday.bind(this);
    this.handleChangeOtherMail = this.handleChangeOtherMail.bind(this);
    this.handleChangePhone = this.handleChangePhone.bind(this);
    this.handleChangeAddress = this.handleChangeAddress.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  handleChangeBirthday(event) {
    this.setState({birthday: event.target.value});
  }
  handleChangeOtherMail(event) {
    this.setState({otherMail: event.target.value});
  }
  handleChangePhone(event) {
    this.setState({phone: event.target.value});
  }
  handleChangeAddress(event) {
    this.setState({address: event.target.value});
  }

  handleSave(event) {
    var userId = firebase.auth().currentUser.uid
    const rootRef = firebase.database().ref('users/').child(userId).child('UserProfile')
    rootRef.update({
      birthday: this.state.birthday,
      otherMail: this.state.otherMail,
      phone: this.state.phone,
      address: this.state.address ? this.state.address : null
    })
  }
  componentDidMount() {
    window.scrollTo(0,0)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        var userId = firebase.auth().currentUser.uid
        const rootRef = firebase.database().ref('users/').child(userId).child('UserProfile')
        rootRef.on('value', snap => {
          this.setState({
            email: snap.val().email,
            displayName: snap.val().displayName,
            photoURL: snap.val().photoURL,
            birthday: snap.val().birthday,
            otherMail: snap.val().otherMail,
            phone: snap.val().phone,
            address: snap.val().address,
          })

        })


      } else {
        window.location = ('/')
      }
    })
  }
  render() {
    return(
      <article className="Box">
        <MetaTags>
            <title>草學藥事 || 修改個人資料</title>
            <meta id="og-title" property="og:title" content="修改個人資料" />
        </MetaTags>
       <h3>修改個人檔案</h3>
       <form onSubmit={this.handleSave}>

         <div className="tableMasonry2" style={Jeyu.MrTop}>
           <div className="tgroup">
            <label htmlFor="userBirthday">*出生日期:</label>
            <input type="text" pattern="^\d{4}/\d{2}/\d{2}$" id="userBirthday" value={this.state.birthday} onChange={this.handleChangeBirthday} required="true" placeholder="生日 格式為:1978/01/23" />
            <small>格式為:1978/01/23</small>
           </div>

           <div className="tgroup">
            <label htmlFor="userEmail">*電子信箱:</label>
            <input type="email" id="userEmail" value={this.state.otherMail} onChange={this.handleChangeOtherMail} required="true" placeholder="請輸入電子信箱" />
           </div>

           <div className="tgroup">
            <label htmlFor="userPhone">*手機號碼:</label>
            <input type="text" pattern="^\d{4}-\d{3}-\d{3}$" id="userPhone" value={this.state.phone} onChange={this.handleChangePhone} required="true" placeholder="手機 格式為:09xx-xxx-xxx" />
            <small>格式為:09xx-xxx-xxx</small>
           </div>

          </div>
          <div className="group">
           <label htmlFor="userAddress">聯絡地址:</label>
           <input type="text" value={this.state.address} id="userAddress" onChange={this.handleChangeAddress} placeholder="請輸入地址" />
          </div>
         <input type="submit" value="儲存吧" className="btnDefault" />
       </form>
      </article>

    )
  }
}

const Jeyu = {
  MrTop: {
    marginTop: 30
  }
}



// WEBPACK FOOTER //
// ./src/View/EditPersonal.js